import { isPresentationId } from '../../util';

export function getPlayFrom(queryString) {
    const urlParams = new URLSearchParams(queryString.toLowerCase());
    const playFromParam = urlParams.get('playfrom');
    if (playFromParam) {
        return parseFloat(playFromParam) / 1000;
    }
}

export function getDuration(queryString) {
    const urlParams = new URLSearchParams(queryString.toLowerCase());
    const durationParam = urlParams.get('duration');
    if (durationParam) {
        return parseFloat(durationParam) / 1000;
    }
}

export function getPresentationId(pathname, dataPresentationId) {
    if (isPresentationId(dataPresentationId)) {
        return dataPresentationId;
    }

    const splitPath = pathname.split('/');
    const presentationId = splitPath[splitPath.length - 1];

    if (isPresentationId(presentationId)) {
        return presentationId;
    }

    //a reason why this might not be an id if because, previously, we added the player guids to the URL with dashes,
    //so just in case someone is still using an old URL (MVP #1144), let's try and remove any dashes and see if it is a presentation id
    const dashlessId = presentationId.replace(/-/g, "");
    if (isPresentationId(dashlessId)) {
        return dashlessId;
    }

    //99% of the time we won't reach this code, but there might be someone throwing around extra '/' in our URLs (MVP #714)
    //if that's the case, let's do the extra work and scan the whole URL to find the part of the URL that's the presentation ID
    const foundId = splitPath.find(part => isPresentationId(part));

    //if there is a valid id in the pathname, return it. If there isn't (we might be showing a player or layout id instead), return whatever was after the last slash
    return foundId ?? presentationId;
}

export function getLockControls(queryString) {
    const urlParams = new URLSearchParams(queryString.toLowerCase());
    const lockControlsValue = urlParams.get('lockcontrols');
    return (lockControlsValue === 'true');
}

export class QueryStringParamProvider {
    #rawParams;
    #lowerParams;

    constructor(queryString) {
        this.#rawParams = new URLSearchParams(queryString.toLowerCase());
        this.#lowerParams = new URLSearchParams();
        for (const [name, value] of this.#rawParams) {
            this.#lowerParams.append(name.toLowerCase(), value);
        }
    }

    getParam(paramName) {
        paramName = paramName.toLowerCase();
        return this.#lowerParams.get(paramName);
    }

    getParamCaseSensitive(paramName, defaultValue) {
        return this.#rawParams.get(paramName);
    }

    /**
     * When passing in an array of options, it will return the value that it first finds. If none is found, return null.
     * @param {Array} paramArray
     */
    getParamFromOptions(paramArray) {
        let returnParam = null;
        for (let param of paramArray) {
            let paramName = param.toLowerCase();
            let paramOption = this.#lowerParams.get(paramName);
            if (paramOption !== null) {
                returnParam = paramOption;
                break;
            }
        }

        return returnParam;
    }
}